import { useLayoutEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { GameProviderMainMenu } from "../GameProviderMainMenu";
import { SCREENS } from "@educaplay/store/constants";
import { setView, startGame } from "@educaplay/store/slices/gameSlice";
import { GameProviderContent } from "../GameProviderContent";
import { GameProviderScore } from "../GameProviderScore";
import styles from './GameproviderView.module.scss';
import PropTypes from 'prop-types';
import GameproviderViewTutorial from "./GameproviderViewTutorial";
import clsx from "clsx";

export function GameProviderView(props) {
    const { gameImage, gameTutorial, Game, hasCustomLayout, classes: customClasses } = props

    const [showScoreScreen, setShowScoreScreen] = useState(false);
    const dispatch = useDispatch();
    const screen = useSelector(state => state.game.view);
    const backgroundImage = useSelector(state => state.settings.customizations.backgroundImage);
    const gameContentRef = useRef();
    const mainMenuRef = useRef();
    const [showTutorial, setShowTutorial] = useState(gameTutorial?.image !== undefined);
    useLayoutEffect(() => {
        setShowScoreScreen(false);
        if (screen === SCREENS.SCORE_SCREEN) {
            gameContentRef.current.animateExit().then(() => {
                setShowScoreScreen(true);
            })
        }
    }, [screen])

    const handleStartGame = () => {
        dispatch(startGame());
    }

    const handleRestartGame = () => {
        dispatch(setView(SCREENS.MAIN_MENU));
        setTimeout(() => {
            mainMenuRef.current?.start();
        }, 400)
    }

    if (screen === SCREENS.MAIN_MENU) {
        return (
            <GameProviderMainMenu
                gameImage={gameImage}
                ref={mainMenuRef}
                onStart={handleStartGame}
            />
        )
    }

    const showBackgroundImage = backgroundImage.showGame && backgroundImage.src 
    
    return (
        <>
            <div className={clsx(styles.gameScreen, customClasses.screen)} style={{ backgroundImage: showBackgroundImage ? `url(${backgroundImage.src})` : 'none' }}>
                {showBackgroundImage && (<div className={styles.gameScreenShadow} />)}

                <div className={styles.container}>
                    <GameProviderContent ref={gameContentRef} Game={Game} hasCustomLayout={hasCustomLayout} classes={customClasses} />
                </div>
                <div id="swipeable-drawer-portal-element"/>
            </div>

            {showTutorial && (
                <GameproviderViewTutorial
                    imageSource={gameTutorial.image}
                    onClose={() => setShowTutorial(false)}
                    delay={gameTutorial.delay}
                    duration={gameTutorial.duration}
                />
            )}

            {showScoreScreen && (
                <GameProviderScore onRestart={handleRestartGame} />
            )}
        </>
    );
}


GameProviderView.propTypes = {
    gameImage: PropTypes.string.isRequired,
    Game: PropTypes.any.isRequired,
    hasCustomLayout: PropTypes.bool,
    gameTutorial: PropTypes.shape({
        image: PropTypes.string.isRequired,
        duration: PropTypes.number.isRequired
    }),
    classes: PropTypes.object
}